import { atom } from 'recoil';

// Version number to force module refresh
const MODULE_VERSION = Date.now();

/*
todo:Dev Variables
 */

// export const API_BASE_URL = "http://10.20.9.120:5000/"; //Dev
// export const BASE_URL = "http://10.20.9.120:3001/"; //Dev
// export const BASE_URL_DASHBOARD = "http://10.20.9.120:3000/";  //Dev




/*
todo: Test Variables
 */


// export const API_BASE_URL = "https://apitest.e-faciliti.dz/"; //Test
// export const BASE_URL = "https://beatest.e-faciliti.dz"; //Test
// export const BASE_URL_DASHBOARD = "https://dashboardtest.e-faciliti.dz/"; //Test

/*
todo: Production Variables
 */
export const API_BASE_URL = "https://api.e-faciliti.dz/"; //Production
export const BASE_URL = "https://bea.e-faciliti.dz";  //Production
export const BASE_URL_DASHBOARD = "https://dashboard.e-faciliti.dz/";  //Production
//
/*
todo: Simulator Principal
*/
export const Simulator = (age, salary, _total, duration, isPremiumClient) => {
    // Cache busting - force function to be re-evaluated
    // console.log("Simulator =========================");
    // console.log("age =========================",age);
    // console.log("salary =========================",salary);
    // console.log("total =========================",_total);
    // console.log("duration =========================",duration);
    // console.log("isPremiumClient =========================",isPremiumClient);
    // console.log("========================");
   
    let versement = [];
    let variables = null;
    var ageClient = age ? age : 18;
    var salaryClient = salary ? salary : 30000;
    var totalClient = _total ? _total : 0;
    var duration = duration ? duration : 48;
    let hamishEldjedia = 0.00;
    
    // Simplified premium check
    var isPremiumIdentifier = Boolean(isPremiumClient);
    
    
    // Calculate TMM based on premium status
    // Calculate TMM using the formula: tmm = (((0.19 * tma) + tma) / 1200)
    // tma is 3% for premium, 7.5% for regular
    // var tma = isPremiumIdentifier ? 3 : 7.5; // tma in percent
    // var TMM = (((0.19 * tma) + tma) / 1200);
    var TMM = isPremiumIdentifier ? 
        (((0.19 * 0.03) + 0.03) / 12) : // Premium rate (3%)
        (((0.19 * 0.075) + 0.075) / 12); // Regular rate (7.5%)

    
    // hamish eldjedia is 10% if the no premium identifier
    // hamish eldjedia is 0% if the premium identifier
    // if (isPremiumIdentifier) {
    //     hamishEldjedia = 0.00;
    // } else {
    //     hamishEldjedia = totalClient * 0.1;
    // }
 
    var CE = ((salaryClient * 0.3) * (1 - Math.pow((1 + TMM), - duration))) / TMM;


    var CETrue = parseFloat(CE.toFixed(6));

    CETrue = CETrue > totalClient ? totalClient:CETrue;

    var tala = 0.00;
    var mar_tva = 0.00;
    var mar = 0.00;
    var amor = 0.00;
    var tva = 0.00;
    var echp = 0.00;
    var totalSimulator = 0.00;
    var mac = 0.0;

    if (!isPremiumIdentifier) {
        if (CETrue > totalClient * 0.9) {
            CETrue = totalClient * 0.9;
            CE = CETrue;
            hamishEldjedia = totalClient * 0.1;
        } else {
            hamishEldjedia = totalClient - CETrue;
        }
    } else {
        // Premium client: max 100% financing
        if (CETrue < totalClient) {
            // Calculate down payment first
            hamishEldjedia = totalClient - CETrue;
            // For premium clients, we can finance up to 100%, so adjust CETrue
        } else {
            // If CE is sufficient, no down payment needed
            // hamishEldjedia = totalClient - CETrue;
            hamishEldjedia = 0;
        }
    }
    

    // todo: calculer Assurance CAAT 
    if (duration <= 12) {
        mac = (CETrue * 1.23 * 1.19) / (100);
    } else if (duration <= 24) {
        mac = (CETrue * 1.30 * 1.19) / (100);
    } else if (duration <= 36) {
        mac = (CETrue * 1.35 * 1.19) / (100);
    } else {
        mac = (CETrue * 1.38 * 1.19) / (100);
    }

    // todo: calculer Assurance TALA
    if (ageClient < 70) {
        // console.log("ageClient =========================",ageClient);
        // console.log("isPremiumIdentifier =========================",isPremiumIdentifier);
        // console.log("CETrue =========================",CETrue);
        // console.log("TMM =========================",TMM);
        // console.log("duration =========================",duration);
        if (isPremiumClient) {

            tala = CETrue / 100; // 1% for premium clients
        } else {
            tala = (CETrue * 1.81) / (100); // 1.81% for general public
        }
    } else {
        tala = (CETrue * 7 * 1.19) / (100); // Keep existing rate for clients >= 70
    }

    var mec = CETrue * ((TMM * Math.pow(1 + TMM, duration)) / (Math.pow(1 + TMM, duration) - 1));

    var enCours = CE;

    while (enCours >>> 0.00) {
        mar_tva = TMM * enCours;

        mar = mar_tva / (1 + 0.19);

        amor = mec - mar_tva;

        tva = mar_tva - mar;

        echp = mar + amor + tva;

        totalSimulator = totalSimulator + parseInt(echp);

        enCours = enCours - amor;
        versement.push({
            "versement": enCours,
            "mar_tva": mar_tva,
            "mar": mar,
            "amor": amor,
            "tva": tva,
            "echp": parseInt(echp)
        });
    }

    variables = {
        "Duration": duration,
        "Salary": salaryClient,
        "TotalPanier": parseInt(totalClient),
        "hamishEldjedia": hamishEldjedia,
        "CE": CETrue,
        "CAAT": mac,
        "tala": tala,
        "TMM": TMM,
        "mec": mec,
        "total": parseFloat(totalSimulator),
        "prix": parseFloat(totalSimulator) + hamishEldjedia,
        "versement": versement
    };

    return variables;
}

export const REACT_APP_SITE_KEY = "6LdV9cUiAAAAAIeDzJAUf4yg2WKm4eiak1EpiLdl"